// db.ts
import { Injectable } from "@angular/core";
import Dexie, { Table } from "dexie";
import { environment } from "../../../../environments/environment";
import { DbTranslations } from "./models/db-translations.model";

@Injectable({
  providedIn: "root"
})
export class AppDBService extends Dexie {
  translations!: Table<DbTranslations, string>;

  constructor() {
    super(environment.appDB.name);

    this.version(environment.appDB.version).stores({
      // List of db tables
      translations: "&languageCode" // Define indexes for table
    });
  }
}
